import { AddCustomerEmployeeContactInput } from "..";

export class AddCustomerEmployeeInput {
    public fullName: string = '';
    public email: string = '';
    public businessRoleId: number = 0;
    public personalPictureFile: string = '';
    public personalPictureFileName: string = '';
    public addCustomerEmployeeContacts: Array<AddCustomerEmployeeContactInput> = [];
}
